import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import { useEffect } from "react";
// import { initGA, logPageView } from "./gaConfig";  // ✅ Import GA

import Home from "./pages/Home";
import Repair from "./pages/Repair";
import Login from "./pages/Login";
import List from "./pages/list";
import Status from "./pages/Status";

function App() {
  return (
    <Router> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/repair" element={<Repair />} />
        <Route path="/login" element={<Login />} />
        <Route path="/status" element={<Status />} />
        <Route path="/repair/list/:id" element={<List />} /> {/* ต้องเป็น :id */}
      </Routes>
    </Router>
  );
}

export default App;